/**
 * Agentic Payment User Balances - Shared Constants
 *
 * Centralized configuration values used across user balances components.
 */

// Pagination Configuration
export const WALLETS_PER_PAGE = 50;

// View modes
export const VIEWS = {
  WALLETS: "wallets",
  BALANCES: "balances",
};

// All API calls go through Rails admin page_action proxy endpoints.
// The Rails layer signs requests with ENCRYPTION_KEY server-side, // no secrets are ever sent to or stored in the browser.
export const API_ENDPOINTS = {
  HEDERA_WALLETS: "/admin/agentic_payment_user_balance/hedera_wallets",
  CREATED_TOKENS: "/admin/agentic_payment_user_balance/created_tokens",
  ACCOUNT_INFO: "/admin/agentic_payment_user_balance/account_info",
  TOKEN_BALANCE: "/admin/agentic_payment_user_balance/token_balance",
  WALLET_BALANCES: "/admin/agentic_payment_user_balance/wallet_balances",
  ESCROW_BALANCE: "/admin/agentic_payment_user_balance/escrow_balance",
  DYNAMIC_FEE: "/admin/agentic_payment_user_balance/dynamic_fee",
  AGENT_WALLETS: "/admin/agentic_payment_user_balance/agent_wallets",
};
